import { useState } from 'react';
import { useBlog } from '../context/BlogContext';
import { motion } from 'framer-motion';

export default function SubscribeBox() {
  const { addSubscriber } = useBlog();
  const [email, setEmail] = useState('');
  const [status, setStatus] = useState(''); // 'success' | 'error' | 'saving'

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!email.trim() || !/\S+@\S+\.\S+/.test(email)) {
      setStatus('error');
      return;
    }
    setStatus('saving');
    try {
      await addSubscriber(email.trim().toLowerCase());
      setEmail('');
      setStatus('success');
      setTimeout(() => setStatus(''), 4000);
    } catch {
      setStatus('error');
    }
  };

  return (
    <motion.section
      initial={{ opacity: 0, y: 30 }}
      whileInView={{ opacity: 1, y: 0 }}
      viewport={{ once: true, margin: '-60px' }}
      transition={{ duration: 0.6 }}
      style={{
        background: 'var(--bg-sidebar)',
        border: '1px solid var(--border-light)',
        borderRadius: 'var(--radius-lg)',
        padding: '3.5rem 2rem',
        textAlign: 'center',
        margin: '3.5rem 0 0',
      }}
    >
      <h3 style={{
        fontFamily: 'var(--font-serif)',
        fontSize: 'clamp(1.5rem, 3vw, 2rem)',
        fontWeight: 400,
        lineHeight: 1.3,
        marginBottom: '1.5rem',
        color: 'var(--text-primary)',
      }}>
        Be the first to know about every new letter.
      </h3>

      <form onSubmit={handleSubmit} className="subscribe-form" style={{
        display: 'flex', gap: '0.5rem',
        justifyContent: 'center', maxWidth: '420px',
        margin: '0 auto 1rem',
      }}>
        <input
          type="email"
          placeholder="Your email address"
          value={email}
          onChange={(e) => { setEmail(e.target.value); setStatus(''); }}
          style={{
            flex: 1,
            padding: '0.65rem 1rem',
            borderRadius: '8px',
            border: `1px solid ${status === 'error' ? 'var(--accent-warm)' : 'var(--border-subtle)'}`,
            background: 'var(--bg-input)',
            fontSize: '0.88rem',
            fontFamily: 'var(--font-sans)',
            color: 'var(--text-primary)',
            outline: 'none',
            transition: 'border-color 0.2s',
          }}
          onFocus={(e) => { e.target.style.borderColor = 'var(--text-primary)'; }}
          onBlur={(e) => { if (status !== 'error') e.target.style.borderColor = 'var(--border-subtle)'; }}
        />
        <button
          type="submit"
          disabled={status === 'saving'}
          style={{
            padding: '0.65rem 1.4rem',
            borderRadius: '8px',
            background: 'var(--text-primary)',
            color: 'var(--bg-body)',
            border: 'none',
            fontSize: '0.88rem',
            fontFamily: 'var(--font-sans)',
            cursor: status === 'saving' ? 'wait' : 'pointer',
            whiteSpace: 'nowrap',
            transition: 'all 0.2s',
          }}
        >
          {status === 'saving' ? 'Subscribing...' : 'Subscribe'}
        </button>
      </form>

      {status === 'success' && (
        <p style={{ fontSize: '0.82rem', color: 'var(--accent-warm)', marginBottom: '0.25rem' }}>
          You're in! Thanks for subscribing.
        </p>
      )}
      {status === 'error' && (
        <p style={{ fontSize: '0.82rem', color: 'var(--accent-warm)', marginBottom: '0.25rem' }}>
          Please enter a valid email address.
        </p>
      )}

      <p style={{ fontSize: '0.78rem', color: 'var(--text-tertiary)' }}>
        No spam, unsubscribe anytime.
      </p>
    </motion.section>
  );
}